// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("PPL_logo.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --gray-offset: rgba(0, 0, 0, 0.03);
  --gray-border: rgba(0, 0, 0, 0.15);
  --gray-light: rgba(0, 0, 0, 0.4);
  --gray-mid: rgba(0, 0, 0, 0.7);
  --gray-dark: rgba(0, 0, 0, 0.9);
  --body-color: var(--gray-mid);
  --headline-color: var(--gray-dark);
  --accent-color: #0066f0;
  --body-font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  --radius: 6px;
  --logo-image: url("https://storage.googleapis.com/stripe-sample-images/KAVHOLM.svg");
  --logo-new: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --form-width: 343px;
}

/* Base */
* {
  box-sizing: border-box;
}
body {
  font-family: var(--body-font-family);
  font-size: 16px;
  color: var(--body-color);
  -webkit-font-smoothing: antialiased;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--body-color);
  margin-top: 2px;
  margin-bottom: 4px;
}
h1 {
  font-size: 27px;
  color: var(--headline-color);
  line-height: 30px;
}
h4 {
  font-weight: 500;
  font-size: 14px;
  color: var(--gray-light);
}

/* Layout */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sr-root {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 980px;
  padding: 48px;
  align-content: center;
  justify-content: center;
  height: auto;
  margin: 0 auto;
}
.sr-header {
  margin-bottom: 32px;
}
.sr-payment-summary {
  margin-bottom: 20px;
}
.sr-main,
.sr-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-self: center;
}
.sr-main {
  width: var(--form-width);
}
.sr-content {
  padding-left: 48px;
}
.sr-header__logo {
  background-image: var(--logo-new);
  height: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
}
.sr-legal-text {
  color: var(--gray-light);
  text-align: center;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}
.sr-field-error {
  color: var(--accent-color);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

.sr-field-success {
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

/* Form */
.sr-form-row {
  margin: 16px 0;
}
label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  display: inline-block;
}

/* Inputs */
.sr-input,
.sr-select,
input[type="text"] {
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  padding: 5px 12px;
  height: 44px;
  width: 100%;
  transition: box-shadow 0.2s ease;
  background: white;
  appearance: none;
  color: #32325d;
}
.sr-input:focus,
.StripeElement--focus,
input[type="text"]:focus,
button:focus,
.focused {
  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),
    0 0 0 4px rgba(50, 151, 211, 0.3);
  outline: none;
  z-index: 9;
}
.sr-input::placeholder,
input[type="text"]::placeholder {
  color: var(--gray-light);
}

/* Checkbox */
.sr-checkbox-label {
  position: relative;
  cursor: pointer;
}

.sr-checkbox-label input {
  opacity: 0;
  margin-right: 6px;
}

.sr-checkbox-label .sr-checkbox-check {
  position: absolute;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
  border: 1px solid var(--gray-border);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.sr-checkbox-label input:focus ~ .sr-checkbox-check {
  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),
    0 0 0 4px rgba(50, 151, 211, 0.3);
  outline: none;
}

.sr-checkbox-label input:checked ~ .sr-checkbox-check {
  background-color: var(--accent-color);
  background-image: url("https://storage.googleapis.com/stripe-sample-images/icon-checkmark.svg");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: -1px -1px;
}

/* Select */
.sr-select {
  display: block;
  height: 44px;
  margin: 0;
  background-image: url("https://storage.googleapis.com/stripe-sample-images/icon-chevron-down.svg");
  background-repeat: no-repeat, repeat;
  background-position: right 12px top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.sr-select:after {
}
.sr-select::-ms-expand {
  display: none;
}
.sr-select:hover {
  cursor: pointer;
}
.sr-select:focus {
  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),
    0 0 0 4px rgba(50, 151, 211, 0.3);
  outline: none;
}
.sr-select option {
  font-weight: 400;
}
.sr-select:invalid {
  color: var(--gray-light);
  background-opacity: 0.4;
}

/* Combo inputs */
.sr-combo-inputs {
  display: flex;
  flex-direction: column;
}
.sr-combo-inputs input,
.sr-combo-inputs .sr-select {
  border-radius: 0;
  border-bottom: 0;
}
.sr-combo-inputs > input:first-child,
.sr-combo-inputs > .sr-select:first-child {
  border-radius: var(--radius) var(--radius) 0 0;
}
.sr-combo-inputs > input:last-child,
.sr-combo-inputs > .sr-select:last-child {
  border-radius: 0 0 var(--radius) var(--radius);
  border-bottom: 1px solid var(--gray-border);
}
.sr-combo-inputs > .sr-combo-inputs-row:last-child input:first-child {
  border-radius: 0 0 0 var(--radius);
  border-bottom: 1px solid var(--gray-border);
}
.sr-combo-inputs > .sr-combo-inputs-row:last-child input:last-child {
  border-radius: 0 0 var(--radius) 0;
  border-bottom: 1px solid var(--gray-border);
}
.sr-combo-inputs > .sr-combo-inputs-row:first-child input:first-child {
  border-radius: var(--radius) 0 0 0;
}
.sr-combo-inputs > .sr-combo-inputs-row:first-child input:last-child {
  border-radius: 0 var(--radius) 0 0;
}
.sr-combo-inputs > .sr-combo-inputs-row:first-child input:only-child {
  border-radius: var(--radius) var(--radius) 0 0;
}
.sr-combo-inputs-row {
  width: 100%;
  display: flex;
}

.sr-combo-inputs-row > input {
  width: 100%;
  border-radius: 0;
}

.sr-combo-inputs-row > input:first-child:not(:only-child) {
  border-right: 0;
}

.sr-combo-inputs-row:not(:first-of-type) .sr-input {
  border-radius: 0 0 var(--radius) var(--radius);
}

/* Buttons and links */
button {
  background: var(--accent-color);
  border-radius: var(--radius);
  color: white;
  border: 0;
  padding: 12px 16px;
  margin-top: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: block;
}
button:hover {
  filter: contrast(115%);
}
button:active {
  transform: translateY(0px) scale(0.98);
  filter: brightness(0.9);
}
button:disabled {
  opacity: 0.5;
  cursor: none;
}

.sr-payment-form button,
.fullwidth {
  width: 100%;
}

a {
  color: var(--accent-color);
  text-decoration: none;
  transition: all 0.2s ease;
}

a:hover {
  filter: brightness(0.8);
}

a:active {
  filter: brightness(0.5);
}

/* Code block */
.sr-callout {
  background: var(--gray-offset);
  padding: 12px;
  border-radius: var(--radius);
  max-height: 200px;
  overflow: auto;
}
code,
pre {
  font-family: "SF Mono", "IBM Plex Mono", "Menlo", monospace;
  font-size: 12px;
}

/* todo: spinner/processing state, errors, animations */

.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: var(--accent-color);
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  transform-origin: 10.4px 10.2px;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: var(--accent-color);
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  transform-origin: 0px 10.2px;
  animation: loading 2s infinite ease;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Animated form */

.sr-root {
  animation: 0.4s form-in;
  animation-fill-mode: both;
  animation-timing-function: ease;
}

.sr-payment-form .sr-form-row {
  animation: 0.4s field-in;
  animation-fill-mode: both;
  animation-timing-function: ease;
  transform-origin: 50% 0%;
}

/* need saas for loop :D  */
.sr-payment-form .sr-form-row:nth-child(1) {
  animation-delay: 0;
}
.sr-payment-form .sr-form-row:nth-child(2) {
  animation-delay: 60ms;
}
.sr-payment-form .sr-form-row:nth-child(3) {
  animation-delay: 120ms;
}
.sr-payment-form .sr-form-row:nth-child(4) {
  animation-delay: 180ms;
}
.sr-payment-form .sr-form-row:nth-child(5) {
  animation-delay: 240ms;
}
.sr-payment-form .sr-form-row:nth-child(6) {
  animation-delay: 300ms;
}

.hidden {
  display: none;
}

@keyframes field-in {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}

@keyframes form-in {
  0% {
    opacity: 0;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsiveness */
@media (max-width: 720px) {
  .sr-root {
    flex-direction: column;
    justify-content: flex-start;
    padding: 48px 20px;
    min-width: 320px;
  }

  .sr-header__logo {
    background-position: center;
  }

  .sr-payment-summary {
    text-align: center;
  }

  .sr-content {
    display: none;
  }

  .sr-main {
    margin-top: 120px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,kCAAkC;EAClC,kCAAkC;EAClC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;EAClC,uBAAuB;EACvB,iEAAiE;EACjE,aAAa;EACb,oFAAoF;EACpF,mDAA+B;EAC/B,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,wBAAwB;EACxB,mCAAmC;AACrC;AACA;;;;;;EAME,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,WAAW;AACX;;;EAGE,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EAGjB,gBAAgB;EAChB,cAAc;AAChB;AACA;;;;;EAKE;qCACmC;EACnC,aAAa;EACb,UAAU;AACZ;AACA;;EAEE,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;qCACmC;EACnC,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,+FAA+F;EAC/F,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,kGAAkG;EAClG,oCAAoC;EACpC,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;AACA;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE;qCACmC;EACnC,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,8CAA8C;EAC9C,2CAA2C;AAC7C;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,2DAA2D;EAC3D,eAAe;AACjB;;AAEA,uDAAuD;;AAEvD;;;EAGE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;EACX,YAAY;EAEZ,+BAA+B;EAE/B,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;EACX,YAAY;EAEZ,4BAA4B;EAE5B,mCAAmC;AACrC;;AAaA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;;AAElB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":["/* Variables */\n:root {\n  --gray-offset: rgba(0, 0, 0, 0.03);\n  --gray-border: rgba(0, 0, 0, 0.15);\n  --gray-light: rgba(0, 0, 0, 0.4);\n  --gray-mid: rgba(0, 0, 0, 0.7);\n  --gray-dark: rgba(0, 0, 0, 0.9);\n  --body-color: var(--gray-mid);\n  --headline-color: var(--gray-dark);\n  --accent-color: #0066f0;\n  --body-font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  --radius: 6px;\n  --logo-image: url(\"https://storage.googleapis.com/stripe-sample-images/KAVHOLM.svg\");\n  --logo-new: url(\"PPL_logo.jpg\");\n  --form-width: 343px;\n}\n\n/* Base */\n* {\n  box-sizing: border-box;\n}\nbody {\n  font-family: var(--body-font-family);\n  font-size: 16px;\n  color: var(--body-color);\n  -webkit-font-smoothing: antialiased;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: var(--body-color);\n  margin-top: 2px;\n  margin-bottom: 4px;\n}\nh1 {\n  font-size: 27px;\n  color: var(--headline-color);\n  line-height: 30px;\n}\nh4 {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--gray-light);\n}\n\n/* Layout */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.sr-root {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  max-width: 980px;\n  padding: 48px;\n  align-content: center;\n  justify-content: center;\n  height: auto;\n  margin: 0 auto;\n}\n.sr-header {\n  margin-bottom: 32px;\n}\n.sr-payment-summary {\n  margin-bottom: 20px;\n}\n.sr-main,\n.sr-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  align-self: center;\n}\n.sr-main {\n  width: var(--form-width);\n}\n.sr-content {\n  padding-left: 48px;\n}\n.sr-header__logo {\n  background-image: var(--logo-new);\n  height: 30px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 100%;\n}\n.sr-legal-text {\n  color: var(--gray-light);\n  text-align: center;\n  font-size: 13px;\n  line-height: 17px;\n  margin-top: 12px;\n}\n.sr-field-error {\n  color: var(--accent-color);\n  text-align: left;\n  font-size: 13px;\n  line-height: 17px;\n  margin-top: 12px;\n}\n\n.sr-field-success {\n  text-align: left;\n  font-size: 13px;\n  line-height: 17px;\n  margin-top: 12px;\n}\n\n/* Form */\n.sr-form-row {\n  margin: 16px 0;\n}\nlabel {\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  display: inline-block;\n}\n\n/* Inputs */\n.sr-input,\n.sr-select,\ninput[type=\"text\"] {\n  border: 1px solid var(--gray-border);\n  border-radius: var(--radius);\n  padding: 5px 12px;\n  height: 44px;\n  width: 100%;\n  transition: box-shadow 0.2s ease;\n  background: white;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  color: #32325d;\n}\n.sr-input:focus,\n.StripeElement--focus,\ninput[type=\"text\"]:focus,\nbutton:focus,\n.focused {\n  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),\n    0 0 0 4px rgba(50, 151, 211, 0.3);\n  outline: none;\n  z-index: 9;\n}\n.sr-input::placeholder,\ninput[type=\"text\"]::placeholder {\n  color: var(--gray-light);\n}\n\n/* Checkbox */\n.sr-checkbox-label {\n  position: relative;\n  cursor: pointer;\n}\n\n.sr-checkbox-label input {\n  opacity: 0;\n  margin-right: 6px;\n}\n\n.sr-checkbox-label .sr-checkbox-check {\n  position: absolute;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: white;\n  border: 1px solid var(--gray-border);\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.sr-checkbox-label input:focus ~ .sr-checkbox-check {\n  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),\n    0 0 0 4px rgba(50, 151, 211, 0.3);\n  outline: none;\n}\n\n.sr-checkbox-label input:checked ~ .sr-checkbox-check {\n  background-color: var(--accent-color);\n  background-image: url(\"https://storage.googleapis.com/stripe-sample-images/icon-checkmark.svg\");\n  background-repeat: no-repeat;\n  background-size: 16px;\n  background-position: -1px -1px;\n}\n\n/* Select */\n.sr-select {\n  display: block;\n  height: 44px;\n  margin: 0;\n  background-image: url(\"https://storage.googleapis.com/stripe-sample-images/icon-chevron-down.svg\");\n  background-repeat: no-repeat, repeat;\n  background-position: right 12px top 50%, 0 0;\n  background-size: 0.65em auto, 100%;\n}\n.sr-select:after {\n}\n.sr-select::-ms-expand {\n  display: none;\n}\n.sr-select:hover {\n  cursor: pointer;\n}\n.sr-select:focus {\n  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),\n    0 0 0 4px rgba(50, 151, 211, 0.3);\n  outline: none;\n}\n.sr-select option {\n  font-weight: 400;\n}\n.sr-select:invalid {\n  color: var(--gray-light);\n  background-opacity: 0.4;\n}\n\n/* Combo inputs */\n.sr-combo-inputs {\n  display: flex;\n  flex-direction: column;\n}\n.sr-combo-inputs input,\n.sr-combo-inputs .sr-select {\n  border-radius: 0;\n  border-bottom: 0;\n}\n.sr-combo-inputs > input:first-child,\n.sr-combo-inputs > .sr-select:first-child {\n  border-radius: var(--radius) var(--radius) 0 0;\n}\n.sr-combo-inputs > input:last-child,\n.sr-combo-inputs > .sr-select:last-child {\n  border-radius: 0 0 var(--radius) var(--radius);\n  border-bottom: 1px solid var(--gray-border);\n}\n.sr-combo-inputs > .sr-combo-inputs-row:last-child input:first-child {\n  border-radius: 0 0 0 var(--radius);\n  border-bottom: 1px solid var(--gray-border);\n}\n.sr-combo-inputs > .sr-combo-inputs-row:last-child input:last-child {\n  border-radius: 0 0 var(--radius) 0;\n  border-bottom: 1px solid var(--gray-border);\n}\n.sr-combo-inputs > .sr-combo-inputs-row:first-child input:first-child {\n  border-radius: var(--radius) 0 0 0;\n}\n.sr-combo-inputs > .sr-combo-inputs-row:first-child input:last-child {\n  border-radius: 0 var(--radius) 0 0;\n}\n.sr-combo-inputs > .sr-combo-inputs-row:first-child input:only-child {\n  border-radius: var(--radius) var(--radius) 0 0;\n}\n.sr-combo-inputs-row {\n  width: 100%;\n  display: flex;\n}\n\n.sr-combo-inputs-row > input {\n  width: 100%;\n  border-radius: 0;\n}\n\n.sr-combo-inputs-row > input:first-child:not(:only-child) {\n  border-right: 0;\n}\n\n.sr-combo-inputs-row:not(:first-of-type) .sr-input {\n  border-radius: 0 0 var(--radius) var(--radius);\n}\n\n/* Buttons and links */\nbutton {\n  background: var(--accent-color);\n  border-radius: var(--radius);\n  color: white;\n  border: 0;\n  padding: 12px 16px;\n  margin-top: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: block;\n}\nbutton:hover {\n  filter: contrast(115%);\n}\nbutton:active {\n  transform: translateY(0px) scale(0.98);\n  filter: brightness(0.9);\n}\nbutton:disabled {\n  opacity: 0.5;\n  cursor: none;\n}\n\n.sr-payment-form button,\n.fullwidth {\n  width: 100%;\n}\n\na {\n  color: var(--accent-color);\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\na:hover {\n  filter: brightness(0.8);\n}\n\na:active {\n  filter: brightness(0.5);\n}\n\n/* Code block */\n.sr-callout {\n  background: var(--gray-offset);\n  padding: 12px;\n  border-radius: var(--radius);\n  max-height: 200px;\n  overflow: auto;\n}\ncode,\npre {\n  font-family: \"SF Mono\", \"IBM Plex Mono\", \"Menlo\", monospace;\n  font-size: 12px;\n}\n\n/* todo: spinner/processing state, errors, animations */\n\n.spinner,\n.spinner:before,\n.spinner:after {\n  border-radius: 50%;\n}\n.spinner {\n  color: #ffffff;\n  font-size: 22px;\n  text-indent: -99999px;\n  margin: 0px auto;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  box-shadow: inset 0 0 0 2px;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n}\n.spinner:before,\n.spinner:after {\n  position: absolute;\n  content: \"\";\n}\n.spinner:before {\n  width: 10.4px;\n  height: 20.4px;\n  background: var(--accent-color);\n  border-radius: 20.4px 0 0 20.4px;\n  top: -0.2px;\n  left: -0.2px;\n  -webkit-transform-origin: 10.4px 10.2px;\n  transform-origin: 10.4px 10.2px;\n  -webkit-animation: loading 2s infinite ease 1.5s;\n  animation: loading 2s infinite ease 1.5s;\n}\n.spinner:after {\n  width: 10.4px;\n  height: 10.2px;\n  background: var(--accent-color);\n  border-radius: 0 10.2px 10.2px 0;\n  top: -0.1px;\n  left: 10.2px;\n  -webkit-transform-origin: 0px 10.2px;\n  transform-origin: 0px 10.2px;\n  -webkit-animation: loading 2s infinite ease;\n  animation: loading 2s infinite ease;\n}\n\n@-webkit-keyframes loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/* Animated form */\n\n.sr-root {\n  animation: 0.4s form-in;\n  animation-fill-mode: both;\n  animation-timing-function: ease;\n}\n\n.sr-payment-form .sr-form-row {\n  animation: 0.4s field-in;\n  animation-fill-mode: both;\n  animation-timing-function: ease;\n  transform-origin: 50% 0%;\n}\n\n/* need saas for loop :D  */\n.sr-payment-form .sr-form-row:nth-child(1) {\n  animation-delay: 0;\n}\n.sr-payment-form .sr-form-row:nth-child(2) {\n  animation-delay: 60ms;\n}\n.sr-payment-form .sr-form-row:nth-child(3) {\n  animation-delay: 120ms;\n}\n.sr-payment-form .sr-form-row:nth-child(4) {\n  animation-delay: 180ms;\n}\n.sr-payment-form .sr-form-row:nth-child(5) {\n  animation-delay: 240ms;\n}\n.sr-payment-form .sr-form-row:nth-child(6) {\n  animation-delay: 300ms;\n}\n\n.hidden {\n  display: none;\n}\n\n@keyframes field-in {\n  0% {\n    opacity: 0;\n    transform: translateY(8px) scale(0.95);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px) scale(1);\n  }\n}\n\n@keyframes form-in {\n  0% {\n    opacity: 0;\n    transform: scale(0.98);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsiveness */\n@media (max-width: 720px) {\n  .sr-root {\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 48px 20px;\n    min-width: 320px;\n  }\n\n  .sr-header__logo {\n    background-position: center;\n  }\n\n  .sr-payment-summary {\n    text-align: center;\n  }\n\n  .sr-content {\n    display: none;\n  }\n\n  .sr-main {\n    margin-top: 120px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
